module.exports = require("./ar-IL.js");